import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";

// export interface District {
//   id?: string;
//   packageName: string;
//   districtCode: string;
//   districtName: string;
//   state: string;
//   status: boolean;
//   createBy?: string;
//   updatedBy?: string;
//   createDate?: string;
//   updateDate?: string;
// }
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInventoryTransferRequest = createAsyncThunk(
  "inventory/fetchInventoryTransferRequest",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await InventoryAxios.get(
        `/item/?${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetch Transfer Request  List error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch Transfer Request List");
    }
  }
);

export const fetchInventoryTransferRequestHistory = createAsyncThunk(
  "inventory/fetchInventoryTransferRequestHistory",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await InventoryAxios.get(
        `/item/?${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetch Transfer Request History List error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch Transfer Request History List");
    }
  }
);
